module.exports = __webpack_public_path__ + "static/media/balizoowebsite2.59ffa066.JPG";